import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { AdministrationService } from '../../../../services/administration.service'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { fuseAnimations } from '../../../../../core/animations'
import 'rxjs/add/operator/distinctUntilChanged'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/switchMap'
import 'rxjs/add/operator/filter'
import { AdministrationModel } from '../../../../models/administration.model'
import { ActivatedRoute, Router } from '@angular/router'
import { SettingsModel } from '../../../../models/settings.model'
import { SettingsService } from '../../../../services/settings.service'
import { FuseTranslationLoaderService } from '../../../../../core/services/translation-loader.service'
import { dutch } from '../../i18n/nl'
import { english } from '../../i18n/en'
import { MatDialog, MatSnackBar } from '@angular/material'
import { TranslateService } from '@ngx-translate/core'
import { CalendarEvent } from 'angular-calendar'
import * as moment from 'moment'
import { Observable, Subscription } from 'rxjs'

@Component({
  selector: 'app-administration-detail',
  templateUrl: './administration-detail.component.html',
  styleUrls: ['./administration-detail.component.scss'],
  animations: fuseAnimations,
})
export class AdministrationDetailComponent implements OnInit, OnDestroy {
  @Input() administration: AdministrationModel

  adminSettings: SettingsModel
  adminForm: FormGroup
  administrationId: number
  @ViewChild('titleInput') titleInputField
  message: string
  isLoading = false
  event: CalendarEvent
  onSettingsChange: Subscription

  constructor(
    private administrationService: AdministrationService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private router: Router,
    private _settingsService: SettingsService,
    private translationLoader: FuseTranslationLoaderService,
    public snackBar: MatSnackBar,
    private translateService: TranslateService,
    public dialog: MatDialog,
  ) {
    this.translationLoader.loadTranslations(dutch, english)
    this.administrationId = this.route.snapshot.params['administrationId']
  }

  ngOnInit() {
    this.adminSettings = this.administration.settings
    this.adminForm = this.createAdminForm()
    this.adminForm.disable()
  }

  /**
   * Create the admin form
   * @returns {FormGroup}
   */
  createAdminForm() {
    return this.formBuilder.group({
      // 'id': [this.administration.id],
      name: [this.adminSettings.company_name, Validators.required],
      coc_number: [this.adminSettings.coc_number],
      start_date: [this.adminSettings.start_date, Validators.required],
      vat_number: [this.adminSettings.vat_number],
      has_vat: [this.adminSettings.has_vat],
      email_address: [this.adminSettings.email_address, Validators.email],
      phone_number: [this.adminSettings.phone_number],
      mobile_number: [this.adminSettings.mobile_number],
      sbi: [this.adminSettings.sbi],
      address_street: [this.adminSettings.address_street],
      address_number: [this.adminSettings.address_number],
      address_number_addition: [this.adminSettings.address_number_addition],
      address_postal_code: [this.adminSettings.address_postal_code],
      address_city: [this.adminSettings.address_city],
      address_country: [this.adminSettings.address_country],
      website: [this.adminSettings.website],
    })
  }

  updateAdministration() {
    this.adminSettings.company_name = this.adminForm.get('name').value
    this.adminSettings.coc_number = this.adminForm.get('coc_number').value
    this.adminSettings.vat_number = this.adminForm.get('vat_number').value
    this.adminSettings.has_vat = this.adminForm.get('has_vat').value
    this.adminSettings.email_address = this.adminForm.get('email_address').value
    this.adminSettings.phone_number = this.adminForm.get('phone_number').value
    this.adminSettings.mobile_number = this.adminForm.get('mobile_number').value

    if (this.adminForm.get('sbi').value instanceof String) {
      this.adminSettings.sbi = this.adminForm.get('sbi').value.split(',')
    }

    this.adminSettings.address_street = this.adminForm.get('address_street').value
    this.adminSettings.address_number = this.adminForm.get('address_number').value
    this.adminSettings.address_number_addition = this.adminForm.get('address_number_addition').value
    this.adminSettings.address_postal_code = this.adminForm.get('address_postal_code').value
    this.adminSettings.address_city = this.adminForm.get('address_city').value
    this.adminSettings.address_country = this.adminForm.get('address_country').value
    this.adminSettings.website = this.adminForm.get('website').value

    this.adminSettings.start_date = moment(this.adminForm.get('start_date').value).format('YYYY-MM-DD')

    this._settingsService
      .update(this.adminSettings)
      .catch(error => {
        this.openSnackBar(error.error.message, 'X')
        return Observable.throw(error)
      })
      .subscribe(adminSettings => {
        this.translateService.get('ADMIN.RESEND_SUCCESS', {}).subscribe((message: string) => {
          this.openSnackBar(message, 'X')
        })
      })
  }

  /**
   * Toggle Deleted
   * @param event
   */
  toggleBlock(event) {
    event.stopPropagation()
  }

  ngOnDestroy() {
    // this.onCurrentadministrationChanged.unsubscribe();
    // this.onSettingsChange.unsubscribe();
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 7000,
    })
  }

  /**
   *
   * @param event
   */
  toggleEdit(event) {
    if (this.adminForm.disabled) {
      this.adminForm.enable()
    } else {
      this.adminForm.disable()
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/administrations/administration-details/administration-detail/administration-detail.component.ts